import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import BaseComponent from 'foundation/base-component';
import store from 'general/js/store';
import WizardDashboard from './data-capture-wizard/wizard-dashboard';

class DataCaptureComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        const options = this.options;
        if (!options.steps) {
            options.steps = [];
        }
        const { imageSource } = options;
        ReactDOM.render(
            <Provider store={store}>
                <div className="data-capture__container container">
                    <div className="content-wrapper">
                        <div
                            className="hero-image"
                            style={{
                                backgroundImage: "url(" + imageSource + ")"
                            }}
                        />

                        <WizardDashboard options={options} />
                    </div>
                </div>
            </Provider>,
            this.element
        );
    }
}

export default DataCaptureComponent;
